module.exports = __webpack_public_path__ + "5e59e02de43dfe9de3e2399546ea6040.svg";